import React, {
    useEffect,
    useState,
} from 'react';

import { useQuery } from '@tanstack/react-query';

import config from "../config/config";
import * as QUERIES from "../queries/query-functions";

export default function TransactionCommissionMessage() {
    const [isTransactionCommission, setIsTransactionCommission] = useState(false);

    const { data: eventInstancesData } = useQuery({
        queryKey: ["eventInstancesData", config.EVENT.event_id],
        queryFn: () => QUERIES.getEventInstances(config.EVENT.event_id),
        staleTime: 86400000,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (!eventInstancesData) return;

        const instance_data = eventInstancesData.find(
            (instance) => instance.id == config.INSTANCE_ID
        );
        // If no data, exit
        if (!instance_data) return;

        const transaction_commission = instance_data.attribute_TransactionCommissionEventInstanceType;

        if(!transaction_commission || transaction_commission == "No Commission") return;

        setIsTransactionCommission(!!transaction_commission);
    }, [eventInstancesData])
    
    return (
        isTransactionCommission && <p><strong>Fees and charges:</strong> Please note all orders are subject to a non-refundable <a href="/seating-and-prices">£2.50 booking fee</a>. Free events are excluded.</p>
    )
}